import React, { Fragment, useCallback, useState } from 'react';
import { FormBlock, PlaceHolderInject } from '../../types/general';
import * as Schema from '../../types/schema';
import { DefaultBlockWrapper, PropsDriller } from './Form';
import Component from './Component';
import Field from './LocalizedField';

function Columns(props: FormBlock<Schema.Columns>) {
	const { schema, options = {} } = props;
	const { BlockWrapper = DefaultBlockWrapper } = options;
	const [placeHolder, setPlaceHolder] = useState<PlaceHolderInject>();
	const id = schema.id;
	const drill = PropsDriller(props);

	const onPlaceHolder = useCallback((args: PlaceHolderInject) => {
		setPlaceHolder(args);
	}, []);

	const getColumnSize = useCallback(
		(index: number) => {
			const size = (schema.defaultSizes || {})[index] || 12 / schema.columns!.length;
			return size;
		},
		[schema.defaultSizes, schema.columns]
	);

	return (
		<BlockWrapper id={id} type='columns' schema={schema}>
			<div id={id} key={id} className='columns row' /* style={rowStyle} */>
				{!schema.columns ||
					(schema.columns.length === 0 && placeHolder && <div className='col'>{placeHolder.element}</div>)}
				{schema.columns
					? schema.columns.map((item, index) => {
							return (
								<Fragment key={index}>
									<div className={'col-md-' + getColumnSize(index)}>
										<BlockWrapper
											id={item.id}
											type='column'
											schema={schema}
											onPlaceHolder={onPlaceHolder}
										>
											{!item.type &&
												placeHolder &&
												placeHolder.parent === item.id &&
												placeHolder.element}
											<Fragment>
												{item.type === 'component' ? (
													<Component schema={item as Schema.Component} {...drill} />
												) : item.type === 'field' ? (
													<Field schema={item as Schema.Field} {...drill} />
												) : null}
											</Fragment>
										</BlockWrapper>
									</div>
								</Fragment>
							);
					  })
					: null}
			</div>
		</BlockWrapper>
	);
}

export default Columns;
